<template>
	<div>
		<Card no-body>
			<b-row v-if="headerTitle" align-v="center" slot="header">
				<b-col>
					<h3 class="mb-0">{{ headerTitle }}</h3>
				</b-col>
				<b-col v-if="headerButtonData" cols="4" class="text-right">
					<BaseButton
						@click="headerButtonClicked"
						:disabled="headerButtonData.isDisabled"
						size="sm"
						>{{ headerButtonData.title }}</BaseButton
					>
				</b-col>
			</b-row>
			<BaseInput
				id="filter-input"
				v-model="filter"
				type="search"
				class="mb-0 mt-3 mx-3"
				placeholder="Type to Search"
				prependIcon="fa fa-search"
			></BaseInput>

			<b-table
				:fields="tableHeaders"
				:items="tableData"
				:busy="isLoading"
				:filter="filter"
				small
				hover
				responsive="sm"
				@row-clicked="rowClicked"
				class="px-1"
			>
				<template #table-busy>
					<b-overlay :show="isLoading" rounded="sm" no-wrap />
				</template>
				<template #cell(leaderboardPoints)="data"> {{ data.item.leaderboardPoints }} </template>
				<template #cell(leaderboardIsActive)="data">
					<BaseSwitch
						:value="data.value"
						:type="'success'"
						@input="switchChanged($event, data)"
					/>
				</template>
				<template #cell(actions)="row">
					<b-dropdown id="actions" variant="null" dropleft no-caret class="m-0 p-0"
						><template #button-content><i class="fas fa-ellipsis-v"></i> </template>
						<b-dropdown-item v-if="row.item.qrCodePhotoURL" @click="viewQRClicked(row.item)"
							>View QR Code</b-dropdown-item
						>
						<b-dropdown-divider></b-dropdown-divider>
						<b-dropdown-item variant="danger" @click="deleteClicked(row.item)"
							>Delete</b-dropdown-item
						>
					</b-dropdown>
				</template>
			</b-table>
			<hr class="my-2" />
			<b-row>
				<b-col></b-col>
				<b-col class="text-right">
					<h5 class="mx-2 description text-muted">Total: {{ tableData.length }}</h5>
				</b-col>
			</b-row>
		</Card>
	</div>
</template>
<script>
import BaseButton from '../../../components/BaseButton.vue';
import BaseSwitch from '../../../components/BaseSwitch.vue';
import BaseInput from '../../../components/Inputs/BaseInput.vue';
import Card from '../../../components/Cards/Card.vue';
export default {
	components: { BaseButton, BaseSwitch, BaseInput, Card },
	computed: {
		sortOptions() {
			// Create an options list from our fields
			return this.fields
				.filter((f) => f.sortable)
				.map((f) => {
					return { text: f.label, value: f.key };
				});
		},
	},
	props: {
		isLoading: false,
		filter: null,
		headerTitle: {
			type: String,
			default: null,
		},
		headerButtonData: {
			type: Object,
			default: null,
		},
		tableHeaders: {
			type: Array,
			description: 'The fields or table headers',
		},
		tableData: {
			type: Array,
			description: 'Data for table',
		},
	},
	data() {
		return {};
	},
	methods: {
		headerButtonClicked() {
			this.$emit('headerButtonClicked');
		},
		switchChanged(value, data) {
			this.$emit('onChanged', {
				value: value,
				data: data.item,
			});
		},
		generateQRCode(item){
			this.$emit('generateQRCode', item);
		},
		resendClicked(item) {
			this.$emit('resendClicked', item);
		},
		viewQRClicked(item) {
			this.$emit('viewQRClicked', item);
		},
		rowClicked(item) {
			this.$emit('viewClicked', item);
		},
		deleteClicked(item) {
			this.$emit('deleteClicked', item);
		},
	},
};
</script>
